import { merge } from 'lodash-es';

import userResolvers from './user';

export default merge(userResolvers);
